export default "__VITE_ASSET__eb3f8b18__"